<a type="button" class="btn" [href]="link">
  {{ buttonText }}
</a>